const WEB_URL= "https://rem-front-end.vercel.app/"

module.exports= {
    WEB_URL
}
